import React from 'react';
import css from './SignupForm.module.css';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { Icons, SecondaryButton } from '../../../components';
import { Field } from 'react-final-form';

// Simple required validator
const required = value => (value ? undefined : 'This field is required');

// Helper function to remove any leading http:// or https:// (repeated or otherwise),
// then prepend a single https://.
const parseUrl = value => {
  if (!value) return value;
  // Trim whitespace
  let trimmed = value.trim();
  // Remove one or more leading occurrences of http:// or https:// (case-insensitive)
  trimmed = trimmed.replace(/^(https?:\/\/)+/i, '');
  // Always add 'https://' prefix
  return `https://${trimmed}`;
};

const validateUrl = value => {
  if (!value) return 'This field is required';
  // Regex expecting the final URL to start with "https://"
  const urlPattern = /^https:\/\/([\w.-]+)\.([a-z]{2,6})([\/\w .-]*)*\/?$/i;
  return urlPattern.test(value) ? undefined : 'Enter a valid URL';
};

function RenderCustomLinks(props) {
  const { viewport, maxLinks } = props;
  const isMobileLayout = viewport.width && viewport.width > 0 && viewport.width < 768;
  const intl = useIntl();

  return (
    <div className={css.customLinksSection}>
      <FieldArray name="customLinks">
        {({ fields }) => {
          const canAddMore = !maxLinks || fields.length < maxLinks;

          return (
            <div className={css.section}>
              <label className={css.sectionTitle}>
                {intl.formatMessage({ id: 'TalentFormCard.customLinks.title' })}
              </label>

              {fields.map((name, index) => (
                <div key={name} className={classNames(css.customField, css.addCustomField)}>
                  <Field name={`${name}.name`} validate={required}>
                    {({ input, meta }) => (
                      <div className={css.textField}>
                        <input
                          {...input}
                          type="text"
                          className={css.textInputField}
                          placeholder={intl.formatMessage({
                            id: 'TalentFormCard.customLinkNamePlaceholder',
                          })}
                        />
                        {meta.touched && meta.error && (
                          <span className={css.error}>{meta.error}</span>
                        )}
                      </div>
                    )}
                  </Field>

                  <Field name={`${name}.url`} validate={validateUrl} parse={parseUrl}>
                    {({ input, meta }) => (
                      <div className={css.textField}>
                        <input
                          {...input}
                          type="text"
                          className={css.textInputField}
                          placeholder={intl.formatMessage({
                            id: 'TalentFormCard.customLinkUrlPlaceholder',
                          })}
                        />
                        {meta.touched && meta.error && (
                          <span className={css.error}>{meta.error}</span>
                        )}
                      </div>
                    )}
                  </Field>

                  <button className={css.delete} type="button" onClick={() => fields.remove(index)}>
                    {isMobileLayout ? (
                      <>
                        <Icons name="bin" /> Delete
                      </>
                    ) : (
                      <Icons name="bin" />
                    )}
                  </button>
                </div>
              ))}

              {canAddMore ? (
                <SecondaryButton
                  className={css.addBtn}
                  type="button"
                  onClick={() => {
                    if (canAddMore) {
                      fields.push({ name: '', url: '' });
                    }
                  }}
                  disabled={!canAddMore}
                >
                  {intl.formatMessage({ id: 'TalentFormCard.addCustomLink' })}
                </SecondaryButton>
              ) : null}
            </div>
          );
        }}
      </FieldArray>
    </div>
  );
}

export default RenderCustomLinks;
